import CompaniesList from "./CompaniesListView";
export default CompaniesList;
